import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "../components/ui/button";
import { INDUSTRIES, productsForIndustry } from "../mock/mock";

export default function Industries({ onEnquire }) {
  const navigate = useNavigate();
  return (
    <div className="bg-white">
      <section className="bg-[#f7f9fc] py-9">
        <div className="mx-auto max-w-7xl px-4 md:px-8">
          <p className="text-[12px] font-semibold tracking-[0.25em] text-[#f4520b] mb-3">INDUSTRIES WE SERVE</p>
          <h1 className="font-heading text-4xl font-extrabold text-[#1c2e3a]">Comfort Solutions for Every Sector</h1>
          <p className="mt-4 text-slate-600 max-w-2xl">We supply durable, high-quality mattresses in bulk across a wide range of industries, tailored to each sector's needs.</p>
        </div>
      </section>

      <section className="py-14">
        <div className="mx-auto max-w-7xl px-4 md:px-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {INDUSTRIES.map((i) => (
            <button key={i.slug} onClick={() => navigate(`/industries/${i.slug}`)} className="group text-left rounded-xl border border-slate-100 shadow-sm overflow-hidden hover:shadow-lg hover:-translate-y-1 transition-all bg-white">
              <div className="aspect-[16/10] overflow-hidden">
                <img src={i.image} alt={i.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-5">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="font-bold text-[#1c2e3a] text-[17px]">{i.title}</h3>
                  <ArrowRight size={16} className="text-[#f4520b] group-hover:translate-x-1 transition-transform shrink-0" />
                </div>
                <p className="mt-2 text-[14px] text-slate-500">{i.desc}</p>
                <p className="mt-2 text-[12px] font-medium text-slate-400">{productsForIndustry(i.slug).length} products with live pricing</p>
              </div>
            </button>
          ))}
        </div>
        <div className="mx-auto max-w-7xl px-4 md:px-8 mt-12 text-center">
          <Button onClick={onEnquire} className="bg-[#1c2e3a] hover:bg-[#29424f] text-white rounded-md px-8 h-12 font-semibold">Enquire for Your Sector</Button>
        </div>
      </section>
    </div>
  );
}
